<template>
  <v-container fluid>
    <v-row>
      <v-col cols="3">
        <v-card dark min-height="250" color="blue-grey">
          <v-card-title> Auto Cerrar Sesión </v-card-title>
          <v-card-subtitle>
            <label for="numTickets"
              >¿Cerramos las sesiones de forma automática?</label
            >
          </v-card-subtitle>
          <v-card-text>
            <div class="config__input-container">
              <v-checkbox
                v-model="autoCloseSession"
                :label="checkBoxLabel"
                hide-details
                class="shrink mr-2 mt-0"
              ></v-checkbox>
              <v-text-field
                :disabled="!autoCloseSession"
                type="number"
                :autofocus="autoCloseSession"
                :prepend-inner-icon="autoCloseSession ? 'mdi-timer' : ''"
                label="¿En cuanto tiempo?"
                :suffix="autoCloseSession ? 'Minutos' : ''"
                class="text-h6"
              ></v-text-field>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              small
              :disabled="isAutoCloseSessionEditDisabled"
              @click="cancelAutoCloseSession"
            >
              <v-icon small class="mr-1">mdi-close-thick</v-icon>
              Cancelar</v-btn
            >
            <v-btn
              small
              :disabled="isAutoCloseSessionEditDisabled"
              @click="saveAutoCloseSession"
            >
              <v-icon small class="mr-1">mdi-floppy</v-icon>
              Guardar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "SessionesConfig",
  data() {
    return {
      autoCloseSession: false,
      isAutoCloseSessionEditDisabled: false,
    };
  },
  computed: {
    checkBoxLabel() {
      return this.autoCloseSession ? "Des-activar" : "Activar";
    },
  },
  methods: {
    saveAutoCloseSession() {},
    cancelAutoCloseSession() {},
  },
};
</script>